<template functional>
	<nav :class="[data.class, data.staticClass]" class="grid grid-cols-1 gap-16 px-16 py-24 tablet:grid-cols-2 tablet:px-24 tablet:ml-48 tabletWide:grid-cols-4 tabletWide:ml-56 desktop:justify-items-center desktop:gap-8 ">
		<template v-for="(item, i) in props.links" >
			<template v-if="item.href.includes('http')">
				<a :key="'item' + i" :href="item.href" class=" active:text-goPinkDarker flex space-x-8 hover:text-goPinkDark items-center text-goBlue ">
					<img src="/images/blank.svg" :data-src="item.image.mobile.src" decoding="async" :alt="item.image.alt" width="60" height="40" class="lazyload rounded-3 object-cover" />
					<span>{{ item.text }}</span>
				</a>
			</template>

			<template v-else>
				<nuxt-link :key="'item' + i" :to="item.href" active-class="text-goPink" class=" active:text-goPinkDarker flex space-x-8 hover:text-goPinkDark items-center text-goBlue ">
					<img src="/images/blank.svg" :data-src="item.image.mobile.src" decoding="async" :alt="item.image.alt" width="60" height="40" class="lazyload rounded-3 object-cover" />
					<span>{{ item.text }}</span>
				</nuxt-link>
			</template>
		</template>
	</nav>
</template>

<script>
export default {
	props: {
		links: {
			type: Array,
			required: true,
		}
	},
};
</script>
